// MONEY INSIDE A SENTENCE (Astra, 1 Nov 2026): a sentence the server wrote ("Trade: owes 36,725,000 AED at 3.6725",
// "1,250,000 USDT rode on the running account", "3.1842 BTC on Bitget is not in the books") draws each figure with its unit
// the way every figure is drawn — mono, tabular, the figure and its unit one unbreakable piece. The words are untouched;
// only "<figure> <unit>" runs are wrapped. A figure with no unit after it (a rate) stays mono too.
import { Fragment } from 'react';

const UNIT = '(?:AED|INR|USD|EUR|GBP|USDT|USDC|BTC|ETH|TRX|SOL|BNB|APT|TON|GRAM)(?:[·.\\-][A-Z]+)?';
const RUN = new RegExp(`([-+−]?\\d[\\d,]*(?:\\.\\d+)?)(\\s${UNIT}\\b)?`, 'g');

export function MoneyText({ text }: { text: string }) {
  const out: Array<string | { fig: string; unit: string | null }> = [];
  let last = 0;
  for (const m of text.matchAll(RUN)) {
    const at = m.index ?? 0;
    // A bare number with no unit and no separator (a year, a day, a count) is left as words.
    if (!m[2] && !/[,.]/.test(m[1]!)) continue;
    if (at > last) out.push(text.slice(last, at));
    out.push({ fig: m[1]!, unit: m[2] ? m[2].trim() : null });
    last = at + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return (
    <>
      {out.map((x, i) => (typeof x === 'string'
        ? <Fragment key={i}>{x}</Fragment>
        : <span key={i} className="whitespace-nowrap"><span className="font-mono tabular">{x.fig}</span>{x.unit && <> {x.unit}</>}</span>))}
    </>
  );
}
